module.exports = __webpack_public_path__ + "img/trapezoid.c8851b87.svg";